export default __webpack_public_path__ + "ac63a78a56aaf0144ba730d16cdf9821.png";